import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { credentialingSettingsEffects } from 'src/app/credentialing/+store/effects';
import { credentialingReducers } from 'src/app/credentialing/+store/reducers';
import { credentialingFeatureKey } from 'src/app/credentialing/+store/selectors';

export const provideCredentialingStore = (): EnvironmentProviders[] => [
    provideState(credentialingFeatureKey, credentialingReducers),
    provideEffects(credentialingSettingsEffects)
];
